class SpousalInfo {
    public Name: string;
    public Age: number;
    public MedicalProblemsAndFamilyAntecedents: string;
    public Description: string;

    constructor(fields?: Partial<SpousalInfo>) {
        Object.assign(this, fields);
    }
}

export { SpousalInfo };
